import { modalManager } from '@/common/utils/modal/modal-manager'
import { WARNING_LAYER_POPUP_INFO } from '@/common/utils/revocation-defense/const'
export const voucherModal = () => {
  const { openModal } = modalManager()
  // modals
  const modal = {
    openPromotionCancel: (voucherInfo = {}) => {
      openModal.standard({
        voucherInfo,
        component: () =>
          import('@/pages/popup/popups/FirstMonthPromotionCancel.vue'),
      })
    },
    openPromotion: (voucherInfo = {}) => {
      openModal.standard({
        voucherInfo,
        component: () => import('@/pages/popup/popups/FirstMonthPromotion.vue'),
      })
    },
    openInfoSBSPopup: (voucherInfo = {}) => {
      openModal.standard({
        voucherInfo,
        component: () => import('@/pages/popup/popups/InfoSBS.vue'),
      })
    },
    openVoucherChange: (voucherInfo = {}, promotionTitle = '') => {
      openModal.promotion({
        title: WARNING_LAYER_POPUP_INFO.VOUCHER_CHANGE.TITLE({
          promotionTitle,
        }),
        description: WARNING_LAYER_POPUP_INFO.VOUCHER_CHANGE.DESCRIPTION({
          promotionTitle,
        }),
        grayButtonText:
          WARNING_LAYER_POPUP_INFO.VOUCHER_CHANGE.GRAY_BUTTON_TEXT,
        primaryButtonText:
          WARNING_LAYER_POPUP_INFO.VOUCHER_CHANGE.PRIMARY_BUTTON_TEXT,
        voucherInfo,
        type: 'VOUCHER_CHANGE',
        component: () =>
          import('@/pages/popup/popups/PromotionCancelWarningPopup.vue'),
      })
    },
  }

  return {
    modal,
  }
}
